import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { CognitoService } from '../cognito.service';

export const AuthGuard: CanActivateFn = async (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<boolean | UrlTree> => {
  const authService = inject(CognitoService);
  const router = inject(Router);

  const isAuthenticated = await authService.isAuthenticated();

  if (isAuthenticated) {
    const isAuthorized = await authService.isAuthorized();
    if (isAuthorized) {
      return true;
    }

    sessionStorage.setItem('auth_access_denied', '1');
    await authService.signOut();
    return router.createUrlTree(['/auth']);
  }

  sessionStorage.setItem('auth_return_url', state.url || '/home');
  try {
    await authService.signInWithHostedUi();
  } catch (error) {
    console.error('Error iniciando Cognito Hosted UI:', error);
  }
  return false;
};
